/*
 * @Author: wangyueqi
 * @Date: 2024-10-18 15:43:02
 * @LastEditors: wangyueqi
 * @LastEditTime: 2024-11-14 15:16:03
 * @Description: 
 */
const base ={
    // host:'http://192.168.31.183:8080/',
    host:'https://jjyl.tsyyj.com/prod-api/',
    getAllUserList:'api/elderly/list',//查询所有用户
    getAgeDistribution:'api/elderly/getAgeDistribution',//年龄占比1
    getGenderRatio:'api/elderly/getGenderRatio',//性别占比
    getStatisticzl:'api/elderly/getStatisticzl',//自理占比
    getStatisticjz:'api/elderly/getStatisticjz',//居住占比
    getStatisticsh:'api/elderly/getStatisticsh',//生活占比
    getDailyNewUsers:'api/elderly/getDailyNewUsers',//每日新增用户
    // 设备————————————————————————————————————————————————————————————————
    getDevicesTypeProportion:'api/elderly/getDevicesTypeProportion',//设备类型
    getDailyBindUsers:'api/elderly/getDailyBindUsers',//设备类型
    getNumber:'api/elderly/getNumber',//在线设备    
    getSostype:'api/elderly/getSostype',//报警类型   
    SosList:'api/elderly/SosList',//报警类型   
    getMapDataDetails:'api/elderly/getMapDataDetails',//报警类型   
    AIChronicDiseasePrediction:'api/elderly/AIChronicDiseasePrediction',//报警类型   
    getOneDateFromSos:'api/elderly/getOneDateFromSos',//查找报警详情 
    updateSosHandleOnSosld:'api/elderly/updateSosHandleOnSosId',//处理报警 
 
    
    
}   
export default base